var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReviewDescription(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.6875 14.0625H10.3125V15.9375H19.6875V14.0625Z",
    fill: "#D39B09"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3125 9.0625H17.1875V10.9375H10.3125V9.0625Z",
    fill: "#D39B09"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6875 19.0625H10.3125V20.9375H19.6875V19.0625Z",
    fill: "#D39B09"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.1384 2.8125H5.3125V27.1875H24.6875V8.36168L19.1384 2.8125ZM7.1875 25.3125V4.6875H18.3616L22.8125 9.13832V25.3125H7.1875Z",
    fill: "#D39B09"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReviewDescription);
export default __webpack_public_path__ + "static/media/review-description.7089ee33eb258a4dd439136c20d1b69e.svg";
export { ForwardRef as ReactComponent };